module.exports = __webpack_public_path__ + "img/IMG_3450_L_Wood_MockedUp.0f608669.jpg";